import { Component, HostListener, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ConfigurationProcedureModel } from 'src/app/models/configuration';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { ProjectService } from 'src/app/services/project.service';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'app-procedure',
  templateUrl: './procedure.component.html',
  styleUrls: ['../../../app.component.scss'],
  standalone: false
})
export class ProcedureComponent implements OnInit {

  configurationController : ConfigurationService;
  form :FormGroup;
  constructor(configurationController : ConfigurationService,
    private projectService : ProjectService,
    private utilsService : UtilsService,
    public bsModalRef : BsModalRef) {
      this.configurationController = configurationController;
    }

  ngOnInit(): void {
    this.configurationController.saveChangesState();
    this.form = new FormGroup({
      BRNavEnRoute : new FormControl(),
      pRnavTma : new FormControl(),
      pRnavEnRoute : new FormControl(),
      aRnpTma : new FormControl(),
      aRnpEnRoute : new FormControl(),
      distanceFromArpNM : new FormControl(),
      distanceFromArpM : new FormControl(),
      altitudeFt : new FormControl(),
      altitudeM : new FormControl(),
      procedureAlongTrackNM: new FormControl(this.configurationController.currentConfiguration.configurationProcedure.procedureAlongtrackNM,[Validators.min(0.1),Validators.max(5)]),
      procedureAlongTrackM: new FormControl(this.configurationController.currentConfiguration.configurationProcedure.procedureAlongtrackM,[Validators.min(185),Validators.max(9260)]),
      procedureWidthNM : new FormControl(this.configurationController.currentConfiguration.configurationProcedure.procedureWidthNM,[Validators.min(0.1),Validators.max(5)]),
      procedureWidthM : new FormControl(this.configurationController.currentConfiguration.configurationProcedure.procedureWidthM,[Validators.min(185),Validators.max(9260)])

    })
  }

  @HostListener('document:keydown.escape', ['$event'])
  onEscape(event: KeyboardEvent) {
    this.cancelConfiguration(false); // escape key already hides the modal
  }

  cancelConfiguration(hideModal: boolean = true):void {
    this.configurationController.cancelConfigurationPopup();
    hideModal? this.bsModalRef.hide(): false;
  }

  saveConfiguration():void {
    if (!this.projectService.projectEditable()) {
      this.cancelConfiguration();
      return;
    }
    this.configurationController.saveConfigurationPopup(this.form);
    this.bsModalRef.hide();
  }

  updateDistanceFromArpValue(type: string, value: number){
    if(type == "m"){
      this.configurationController.currentConfiguration.configurationProcedure.distanceFromArpM = this.utilsService.nmToMeters(value);
      this.configurationController.currentConfiguration.configurationProcedure.distanceFromArp = value;
    }
    else if(type == "nm"){
      this.configurationController.currentConfiguration.configurationProcedure.distanceFromArpNM = this.utilsService.metersToNm(value);
      this.configurationController.currentConfiguration.configurationProcedure.distanceFromArp = this.utilsService.metersToNm(value);
    }
    else{
      //ERROR
    }
  }

  updateAltitudeValue(type: string, value: number){
    if(type == "m"){
      this.configurationController.currentConfiguration.configurationProcedure.altitudeM = this.utilsService.feetToMeters(value);
      this.configurationController.currentConfiguration.configurationProcedure.altitude = value;
    }
    else if(type == "ft"){
      this.configurationController.currentConfiguration.configurationProcedure.altitudeFt = this.utilsService.metersToFeet(value);
      this.configurationController.currentConfiguration.configurationProcedure.altitude = this.utilsService.metersToFeet(value);
    }
    else{
      //ERROR
    }
  }

  updateProcedureAlongtrackValue(type: string, value: number){
    if(type == "m"){
      this.configurationController.currentConfiguration.configurationProcedure.procedureAlongtrackM = this.utilsService.nmToMeters(value);
      this.configurationController.currentConfiguration.configurationProcedure.procedureAlongtrack = value;
    }
    else if(type == "nm"){
      this.configurationController.currentConfiguration.configurationProcedure.procedureAlongtrackNM = this.utilsService.metersToNm(value);
      this.configurationController.currentConfiguration.configurationProcedure.procedureAlongtrack = this.utilsService.metersToNm(value);
    }
    else{
      //ERROR
    }
  }

  updateProcedureWidthValue(type: string, value: number){
    if(type == "m"){
      this.configurationController.currentConfiguration.configurationProcedure.procedureWidthM = this.utilsService.nmToMeters(value);
      this.configurationController.currentConfiguration.configurationProcedure.procedureWidth = value;
    }
    else if(type == "nm"){
      this.configurationController.currentConfiguration.configurationProcedure.procedureWidthNM = this.utilsService.metersToNm(value);
      this.configurationController.currentConfiguration.configurationProcedure.procedureWidth = this.utilsService.metersToNm(value);
    }
    else{
      //ERROR
    }
  }

  retoreDefaults(){
    let procedureConfiguration: ConfigurationProcedureModel = new ConfigurationProcedureModel();

    procedureConfiguration.bRnavEnRoute = 7;
    procedureConfiguration.pRnavTma = 3;
    procedureConfiguration.pRnavEnRoute = 5;
    procedureConfiguration.aRnpTma = 2.5;
    procedureConfiguration.aRnpEnRoute = 3.5;
    procedureConfiguration.distanceFromArpM = 55560;
    procedureConfiguration.distanceFromArpNM = 30;
    procedureConfiguration.distanceFromArp = 30;
    procedureConfiguration.altitudeM = 3048;
    procedureConfiguration.altitudeFt = 10000;
    procedureConfiguration.altitude = 10000;
    procedureConfiguration.procedureAlongtrackM = 3704;
    procedureConfiguration.procedureAlongtrackNM = 2.0;
    procedureConfiguration.procedureAlongtrack = 2.0;
    procedureConfiguration.procedureWidthM = 1852;
    procedureConfiguration.procedureWidthNM = 1;
    procedureConfiguration.procedureWidth = 1;


    this.configurationController.currentConfiguration.configurationProcedure = procedureConfiguration;
  }
}
